export default __webpack_public_path__ + "static/media/success.09aa8580.svg";